(function (module) {
    "use strict";

    module.service('chamferingBrandCalculationService', ['synchronousEventsBus', 'forecastCacheService',
        function(
            this: $TSFixMe,
            synchronousEventsBus: $TSFixMe,
            forecastCacheService: $TSFixMe
        ) {
            var service = this;

            service.registerEvents = function () {
                synchronousEventsBus.$on('chamferingSkuVolumePmForecastChanged',
                    (e: $TSFixMe, args: $TSFixMe) => service.calculateBrandVolumeAndMkshrForWholeForecast(args.parameters, forecastCacheService.getForecast(), args.forecast));
                synchronousEventsBus.$on('chamferingSkuValuePmForecastChanged', (e: $TSFixMe, args: $TSFixMe) => service.calculateBrandValueForWholeForecast(args.parameters, forecastCacheService.getForecast()));
            }

            service.calculateBrandValueForWholeForecast = (parameters: $TSFixMe, forecast: $TSFixMe) => {
                let promises = [];
                for (const brand of forecast.market.brands) {
                    calculateBrandValue(parameters, brand);
                    promises.push(synchronousEventsBus.$broadcast('chamferingBrandValueForecastChanged', { parameters, brand }));
                }
                return promises;
            }

            function calculateBrandValue(parameters: $TSFixMe, brand: $TSFixMe) {
                
                var forecastLength = Math.floor(moment.utc(parameters.forecastEndDate).diff(moment.utc(parameters.forecastStartDate), 'months')) + 1;

                
                brand.forecast.value.statisticalForecast = _.times(forecastLength, _.constant(0));
                
                brand.forecast.value.pmForecast = _.times(forecastLength, _.constant(0));

                for (let i = 0; i < forecastLength; i++) {
                    for (const sku of brand.skus) {

                        brand.forecast.value.statisticalForecast[i] += angular._get(sku, `forecast.value.statisticalForecast[${i}]`, 0);

                        brand.forecast.value.pmForecast[i] += angular._get(sku, `forecast.value.pmForecast[${i}]`, 0);
                    }
                }
            }

            service.calculateBrandVolumeAndMkshrForWholeForecast = (parameters: $TSFixMe, forecast: $TSFixMe) => {
                let promises = [];
                for (const brand of forecast.market.brands) {
                    calculateBrandVolumeAndMkshr(parameters, brand, forecast.market);
                    promises.push(synchronousEventsBus.$broadcast('chamferingBrandVolumeForecastChanged', { parameters, brand }));
                    promises.push(synchronousEventsBus.$broadcast('chamferingBrandVolumeMkshrChanged', { parameters, brand }));
                }
                return promises;
            }

            function calculateBrandVolumeAndMkshr(parameters: $TSFixMe, brand: $TSFixMe, market: $TSFixMe) {
                
                var forecastLength = Math.floor(moment.utc(parameters.forecastEndDate).diff(moment.utc(parameters.forecastStartDate), 'months')) + 1;

                brand.forecast.volume = {
                    
                    pmForecast: _.times(forecastLength, _.constant(0)),
                    
                    statisticalForecast: _.times(forecastLength, _.constant(0)),
                };

                for (const sku of brand.skus) {
                    for (let i = 0; i < forecastLength; i++) {

                        brand.forecast.volume.statisticalForecast[i] += angular._get(sku, `forecast.volume.statisticalForecast[${i}]`, 0);

                        brand.forecast.volume.pmForecast[i] += angular._get(sku, `forecast.volume.pmForecast[${i}]`, 0);
                    }
                }

                brand.forecast.mkshr = new Array(forecastLength);
                for (let i = 0; i < forecastLength; i++) {
                    brand.forecast.mkshr[i] = 100 * brand.forecast.volume.pmForecast[i] / market.forecast.pmForecast[i];
                }
            }


        }]);

    module.run(['chamferingBrandCalculationService', function (service: $TSFixMe) {
        service.registerEvents();
    }]);


})(angular.module('topline.services'));